var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pv-vis-article-card',_vm._b({attrs:{"article":_vm.article,"cited-by-color":_vm.citedByColorComputed,"reference-color":_vm.referenceColorComputed}},'pv-vis-article-card',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }